/**
 * Settlements Service - API client for school MoMo withdrawal
 * balance, transaction history, and Paystack transfers
 */
import api from '../utils/api';

const settlementsService = {
  getBalance: async () => {
    try {
      return await api.get('/api/settlements/balance');
    } catch (error) {
      console.error('Error fetching settlement balance:', error);
      throw error;
    }
  },

  getRecentTransactions: async (days) => {
    try {
      return await api.get('/api/settlements/transactions/recent', { params: { days } });
    } catch (error) {
      console.error('Error fetching recent settlement transactions:', error);
      throw error;
    }
  },

  getWithdrawalHistory: async () => {
    try {
      return await api.get('/api/settlements/withdrawals/history');
    } catch (error) {
      console.error('Error fetching withdrawal history:', error);
      throw error;
    }
  },

  withdrawToMomo: async (data) => {
    try {
      return await api.post('/api/settlements/withdraw-momo', data);
    } catch (error) {
      console.error('Error initiating MoMo withdrawal:', error);
      throw error;
    }
  },

  verifyTransfer: async (transferCode) => {
    try {
      return await api.post(`/api/settlements/transfer/${transferCode}/verify`);
    } catch (error) {
      console.error('Error verifying transfer:', error);
      throw error;
    }
  }
};

export default settlementsService;
